import * as React from 'react';
import { QuestionResponse } from '../../Types/QuestionResponse';
import { Article } from '../../Types/Article';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

interface QuizQuestionResultExplanationProps {
  questionResponse: QuestionResponse;
  article: Article | null;
}

const QuizQuestionResultExplanation: React.FC<
  QuizQuestionResultExplanationProps
> = ({ questionResponse, article }) => {
  let question = article?.questions.find(
    (question) => question.id === questionResponse.questionId,
  );

  if (!question) {
    // TODO: remove this after the we have visibility about the situation where
    // question might not be found. More details in the issue:
    // https://ws-lambda.atlassian.net/browse/LAMBDA-80968
    console.warn('question not found in QuizQuestionResultExplanation', {
      questionResponse,
      article,
    });
  }

  let questionNumber = question.order + 1;
  let correctAnswer = question.questionOptions[question.correctOptionIndex];
  let explanation = question.correctAnswerExplanation
    ? question.correctAnswerExplanation
    : question.questionOptionExplanations[question.correctOptionIndex];
  return (
    <>
      <div className="justify-between items-stretch flex gap-5 mt-4 max-md:max-w-full max-md:flex-wrap">
        <div className="text-neutral-800 text-opacity-70 text-base">
          Question {questionNumber}
        </div>
        <div
          className={`d-flex align-items-center justify-content-center text-white text-center text-sm font-black tracking-wide aspect-square h-6 px-1.5 rounded-[100px] ${
            questionResponse.answerState === 'correct'
              ? 'bg-green-700'
              : 'bg-red-600'
          }`}
        >
          <div className="pt-0.5">
            {questionResponse.answerState === 'correct' ? (
              <FontAwesomeIcon icon={faCheck} />
            ) : (
              <FontAwesomeIcon icon={faTimes} />
            )}
          </div>
        </div>
      </div>
      {questionResponse.answerState === 'incorrect' && (
        <div
          className="text-neutral-800 text-opacity-70 text-sm mt-2 max-md:max-w-full"
          data-testid="incorrect-answer-explanation"
        >
          <span className="font-bold">Correct Answer:</span>
          <br />
          {correctAnswer} <br /> <br />
          <span className="font-bold">Explanation:</span>
          <br />
          {explanation}
        </div>
      )}
    </>
  );
};

export default QuizQuestionResultExplanation;
